import type { PropertyCompletenessRow } from '../../saber.types'
import {
  completenessBarClass,
  completenessPctColorClass
} from '../../cellColor'

// §9 — Completeness % column helpers (exported for unit tests).

/** Raw completeness % (billed ÷ allocated × 100); null when nothing allocated. */
export const completenessPctRaw = (
  row: Pick<PropertyCompletenessRow, 'allocatedKwh' | 'billedKwh'>
): number | null => (row.allocatedKwh ? (row.billedKwh / row.allocatedKwh) * 100 : null)

/** §9 color thresholds on the RAW value: ≥99 emerald · ≥90 amber · <90 red. */
export const completenessPctClass = completenessPctColorClass

/** Bar fill colors paired with completenessPctClass. */
export { completenessBarClass }

/** Status buckets aligned with backend COMPLETENESS_OK_PCT (98) / WARN (95). */
export const completenessStatusFromPct = (
  pct: number | null
): PropertyCompletenessRow['status'] => {
  if (pct == null) return 'CRITICAL'
  if (pct >= 98) return 'OK'
  if (pct >= 95) return 'WARN'
  return 'CRITICAL'
}
